<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let dt of form?.controls; let i = index">
    <div
      class="repeatable-card-fields"
      formGroupName="DTS">
      <mat-form-field>
        <input
          matInput
          placeholder="Cronologia da (DTSI)"
          formControlName="DTSI">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Cronologia a (DTSF)"
          formControlName="DTSF">
      </mat-form-field>
      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-icon-button
        type="button"
        (click)="removeDTHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addDTHandler()">
    {{ 'Aggiungi cronologia' | translate }}
  </button>
</div>
